
import axios from "axios";
import Config from "src/config";

const v2_actionCriarCalendario = (clienteId, data) => {
    let content = {
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/calendarios/criar`,
        data
    }
    return axios(content);
};
export default v2_actionCriarCalendario;
